import $ from 'jquery';

import BaseController from 'chairisher/_controller';

import {
    AmplitudeEventProperty,
    SellerPlanAction,
    SellerPlanPosition,
    SellerPlanType,
    TrackingScreen,
    logAmplitudeClickEvent,
    logScreenView,
} from 'chairisher/util/analytics';

/**
 * Controller that binds actions for the Platinum Plan page
 */
export default class PlatinumPlanController extends BaseController {
    /** @inheritdoc */
    bindPageActions() {
        super.bindPageActions();

        logScreenView(TrackingScreen.PLATINUM_SELLER_PLAN);

        $('.js-platinum-hero-link-btn').on('click', (e) => {
            e.preventDefault();
            logAmplitudeClickEvent(SellerPlanAction.APPLICATION_CLICK, SellerPlanPosition.SELLER_SIGNUP_TOP, null, {
                [AmplitudeEventProperty.SELLER_PLAN_NAME]: SellerPlanType.PLATINUM,
            });

            $('.js-platinum-join-section').get(0).scrollIntoView({
                behavior: 'smooth',
            });
        });

        $('.js-platinum-join-form input[type="submit"]').on('click', () => {
            logAmplitudeClickEvent(SellerPlanAction.APPLICATION_CLICK, SellerPlanPosition.SELLER_SIGNUP_BOTTOM, null, {
                [AmplitudeEventProperty.SELLER_PLAN_NAME]: SellerPlanType.PLATINUM,
            });
        });
    }
}
